module.exports = __webpack_public_path__ + "img/bitrix-color.f0587677.svg";